import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import {
  LECollectionBookmarks,
  LEBookmarks,
  UnitBookmarks,
  WorksheetBookmarks,
  QuestionBookmarks,
  MockExamBookmarks,
} from "ToddleLibrary/routes/Bookmarks/routes";
export default store => {
  return {
    path: "bookmarked",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "toddle-library" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [
      LECollectionBookmarks(store),
      LEBookmarks(store),
      UnitBookmarks(store),
      WorksheetBookmarks(store),
      QuestionBookmarks(store),
      MockExamBookmarks(store),
    ],
  };
};
